import React from 'react';
import Select from 'Components/Select';
import { Input } from 'Components/Input';

class ComponentGeneralInformation extends React.Component {
  getFieldsBySelectedType = () => {
    const {type, additionalFields, handleAdditionalFieldChange, inputErrors} = this.props;

    if (!type) return null;

    return type.componentTypeFields.map((field, index) => {
      if (!field.active) return null;
      if (field.fieldName === null) field.fieldName = field.fieldNameCode;

      const label = field.required ? `${field.fieldName.toLowerCase()} *` : field.fieldName.toLowerCase();

      if (field.componentTypeFieldValues.length)
        return (
          <Select
            key={field.id}
            type='primary'
            mainWrapperClassName={`${index % 2 === 0 ? '_margin_right_30' : ''}`}
            defaultItem={additionalFields[field.id]}
            selectionList={field.componentTypeFieldValues}
            error={inputErrors[field.id]}
            itemNameIndicator='value'
            label={label}
            capitalizeLabel
            handleSelect={handleAdditionalFieldChange(field.id)}
          />
        );
      else
        return (
          <Input
            mainWrapperClassName={`input__main-wrapper_primary ${index % 2 === 0 ? '_margin_right_30' : ''}`}
            inputClassName='input__input-field_primary'
            key={field.id}
            label={label}
            error={inputErrors[field.id]}
            capitalizeLabel
            value={additionalFields[field.id].value}
            onChange={handleAdditionalFieldChange(field.id)}
          />
        );
    });
  };

  render() {
    const { type } = this.props;

    if (!type) return null;

    return (
      <section className='scene_section'>
        <header>General Information</header>
        {this.getFieldsBySelectedType()}
      </section>
    );
  }
}

export default ComponentGeneralInformation;



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/Application/New/GeneralInformation.jsx